import { useEffect, useRef, useState } from "react";
import "./style.css";
import {send,sendWhite} from "../assets/icons/index"
import { botResponses, chatWarning, OPENAI_API_KEY } from "../Constant/common";


const closeBtn={
  color: "#FFFFFF"
}
const ChatBot = ({darkMode,chatOpen,setChatOpen}) => {
  const chatBoxRef = useRef(null);
  const [isTyping,setTyping] = useState(false)
  const [dotCount, setDotCount] = useState(1);

  const [messages, setMessages] = useState([
    { text: "Hello! How can I help you?", sender: "bot" },
  ]);
  const [input, setInput] = useState("");
 
  // typing message for gpt reply only
  useEffect(()=>{
    if(isTyping){
      const interval = setInterval(() => {
        setDotCount((prev) => (prev < 5 ? prev + 1 : 1));
      }, 100); // Change speed here
      
      return () => clearInterval(interval); // Cleanup
    }
    
  },[isTyping])
  // ✅ FIXED fetchGPTResponse
  const fetchGPTResponse = async (question) => {
    setInput("");
    setTyping(true)
     
    try {
      const response = await fetch('https://api.openai.com/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${OPENAI_API_KEY}`,
        },
        body: JSON.stringify({
          model: 'gpt-4',
          messages: [
            { role: 'system', content: 'You are a helpful assistant.' },
            { role: 'user', content: question },
          ],
        }),
      });
       setInput("");
       setTyping(false)
      const data = await response.json();
      return data.choices[0].message.content;
    } catch (error) {
      setTyping(false)
      console.error('Error calling OpenAI API:', error);
      return "Sorry, I'm having trouble replying right now.";
    }
  };
  
  const sendMessage = async () => {
    if (!input.trim()) return;
  
    const userMessage = { text: input, sender: "user" };
    setMessages((prev) => [...prev, userMessage]);
  
    const lowerInput = input.toLowerCase();
  
    const matched = botResponses.find((item) =>
      item.keywords.some((kw) => lowerInput.includes(kw))
    );
  
    let botText;
  
    if (matched) {
      botText = matched.response;
    } else {
      botText = await fetchGPTResponse(input); // <-- await the async call

    }
  
    const botReply = {
      text: botText,
      sender: "bot",
    };
  
    setMessages((prev) => [...prev, botReply]);
  
    setInput("");
  };


  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      sendMessage();
    }
  };

  useEffect(() => {
    if (chatBoxRef.current) {
      chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
    }
  }, [messages])
  

  return (
        <div className={`chat-container ${!darkMode ? "dark" : "white"}`}>
         <div className="marquee-container" title={chatWarning}>
          <div className="marquee-wrapper">
            <span>{chatWarning}</span>
            <span>{chatWarning}</span>
          </div>
        </div>
          <div className="chat-header">
            <div className="flex items-center space-x-2">
              <div>LIVE CHAT</div>
              <span className="relative flex h-3 w-3">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
              </span>
            </div>
            <button onClick={() => setChatOpen(!chatOpen)} style={closeBtn}>
              ✖️
            </button>
           
            </div>
          <div className="chat-box" ref={chatBoxRef}>
            {messages.map((msg, index) => (
              <div key={index} className={`chat-message ${msg.sender}`}>
                {msg.text}
              </div>
            ))}
            {isTyping && <div className={`chat-message`}>
                <strong style={{color:!darkMode? "white": ""}}>Typing{'.'.repeat(dotCount)}</strong>
              </div>}
          </div>

          <div className="chat-input">
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Type a message..."
            />
            <button onClick={sendMessage}>
              <img src={!darkMode ? sendWhite: send} alt="send-icon" width={'30px'} height={"30px"}/>
            </button>
          </div>
        </div>
  );
};

export default ChatBot;
